<template>
  <div class="modal-card" style="width: auto">
    <header class="modal-card-head">
      <p class="modal-card-title">Viewing Countries</p>
    </header>
    <section class="modal-card-body">
      <div class="block">
        <b-checkbox v-for="(d, i) in newsets" v-model="newsets[i].hidden" :true-value="false" :false-value="true"><span :style="'color:' + d.backgroundColor">{{d.label}}</span></b-checkbox>
      </div>
    </section>
    <footer class="modal-card-foot">
      <button @click="Close(newsets)" class="button is-primary">Update</button>
      <button @click="ClearAll" class="button is-light">Clear All</button>
    </footer>
  </div>
</template>
<script>
  export default {
    data() {
      return { //<i class="fas fa-square" :style="'color:' + d.backgroundColor"></i> //color'd square
        newsets: undefined
      }
    },
    props: {
      datasets: { Array }
    },
    methods: {
      ClearAll() {
        this.newsets.forEach(set => {
          set.hidden = true;
        });
        this.$emit('close', this.newsets);
      },
      Close() {
        this.$emit('close', this.newsets);
      }
    },
    created() {
      this.newsets = this.datasets.map(d => {
        d.hidden = d.hidden ? true : false
        return d;
      });
    },
    mounted() {

    }
  }
</script>
